import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/landing";
type CTAButtonProps = {
  label: string;
  caption?: string;
  id?: string;
  dark?: boolean;
};
export function CTAButton({
  label,
  caption,
  id,
  dark = false
}: CTAButtonProps) {
  return <div id={id} className="mx-auto w-full max-w-xl text-center" data-id="element-28" data-mp="2fzv37a5u8y7b">
      <a href={CHECKOUT_URL} className="flex w-full items-center justify-center gap-3 rounded-2xl bg-cta px-5 py-5 text-[16px] font-extrabold uppercase leading-tight tracking-wide text-white shadow-[0_12px_28px_-10px_rgba(22,163,74,0.75)] transition-[transform,background-color] duration-150 ease-out hover:bg-ctaDark active:scale-[0.98] focus:outline-none focus-visible:ring-4 focus-visible:ring-cta/40 sm:text-xl" data-id="element-29" data-mp="2g1o9gocjhges">
        <span data-id="element-30" data-mp="3cpcblww7gycp">{label}</span>
        <ArrowRightIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-31" data-mp="3cqnja7sruq93" />
      </a>
      {caption && <p className={`mt-3 text-sm leading-relaxed ${dark ? "text-white/75" : "text-ink/65"}`} data-id="element-32" data-mp="38pttt9zol3e3">{caption}</p>}
    </div>;
}